import { isPlainObject } from './is-plain-object';

/**
 * Merge two objects, where obj2 overwrites obj1
 * @param obj1
 * @param obj2
 * @param applyNewFields applies fields from obj2 that are not in obj1
 */
export const mergeObjects = (obj1: any, obj2: any, applyNewFields: boolean = false) => {
  Object.keys(obj2).forEach(function (key) {
    if (key in obj1) {
      if (isPlainObject(obj1[key])) {
        mergeObjects(obj1[key], obj2[key], applyNewFields);
      } else {
        obj1[key] = obj2[key];
      }
    } else if (applyNewFields) {
      obj1[key] = obj2[key];
    }
  });
};
